import React, { Component } from 'react';
import { connect } from 'react-redux';
import ThemeColorSetting from '../constants/themeColor';
import { Grid , List } from 'semantic-ui-react';
import { Link } from "react-router";

const styles = {
  footerWrapper : {
    height : 'auto',
    backgroundColor : ThemeColorSetting.black,
    margin : '0px',
    minHeight : '30vh'
  },
  contactContainer : {
    display : 'flex',
    flexDirection : 'column',
    justifyContent : 'center',
    alignItems : 'flex-start',
    padding : '20px',
    backgroundColor : ThemeColorSetting.black,
  },
  copyRightContainer : {
    display : 'flex',
    flexDirection : 'column',
    justifyContent : 'flex-end',
    paddingBottom : '20px',
    backgroundColor : ThemeColorSetting.black,
    alignItems : 'flex-end'
  },
  description : {
    color : 'white'
  }
}

class Footer extends Component {
  render() {
    const { string } = this.props;
    return(
      <Grid style={styles.footerWrapper} stackable>
        <Grid.Row columns='2' style={{ padding : '0px' }}>
          <Grid.Column style={styles.contactContainer}>
            <h2 style={styles.description}>{string['contactMethod']}</h2>
            <List inverted verticalAlign='middle' size='big'>
              <List.Item>
                <List.Icon name='phone' inverted/>
                <List.Content style={styles.description}>{string['phone']}</List.Content>
              </List.Item>
              <List.Item>
                <List.Icon name='mail' inverted/>
                <List.Content><a href={`mailto:${string['email']}`}>{string['email']}</a></List.Content>
              </List.Item>
              <List.Item>
                <List.Icon name='marker' inverted/>
                <List.Content style={styles.description}>{string['address']}</List.Content>
              </List.Item>
            </List>
          </Grid.Column>
          <Grid.Column style={styles.copyRightContainer}>
            <p style={styles.description}>{string['copyRight']}</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(Footer)



/** WEBPACK FOOTER **
 ** ./src/components/footer.js
 **/